import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import api from "../api/client";

export default function ProjectGuard({ children }: { children: React.ReactNode }) {
  const { projectId } = useParams();
  const [status, setStatus] = useState<"checking" | "allowed" | "denied">("checking");

  useEffect(() => {
    if (!projectId) { setStatus("allowed"); return; }
    api.get("/api/projects")
      .then(r => {
        const hasAccess = r.data.some((p: any) => p.id === projectId);
        setStatus(hasAccess ? "allowed" : "denied");
      })
      .catch(() => setStatus("denied"));
  }, [projectId]);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-sm text-gray-400">Checking access...</p>
      </div>
    );
  }
  if (status === "denied") {
    return <Navigate to="/select-project" replace />;
  }
  return <>{children}</>;
}
